import type { ApiVolopPromotionRadius } from '#/modules/listing/volops/api/types/ApiVolopPromotionRadius';
import type { SearchAlgoliaVolopHit } from '#/modules/search/algolia/types/SearchAlgoliaVolopHit';
import { postJson } from '#/utils/http/postJson';

type ApiResponse = {
  listingPromo: {
    volopHit: SearchAlgoliaVolopHit;
    promotionRadius: ApiVolopPromotionRadius;
  } | null;
};

export async function searchApiFetchPromotedVolop(latLng: {
  latitude: number | null | undefined;
  longitude: number | null | undefined;
}): Promise<ApiResponse> {
  return postJson('/data/website/promoted-listing-for-search', latLng);
}
